import { React, ReactRouter, useAPI } from 'mcelroy-lib'
import { FormPage, useToast, useUserContext } from 'mcelroy-components'
import { useTurnstile } from '../util/Turnstile'


/*
    Page to create new accounts
*/
export function CreateAccountPage() {
    const { wrapperRef, turnstile } = useTurnstile()
    const { user } = useUserContext()
    const navigate = ReactRouter.useNavigate()
    const toast = useToast()

    const { run: createUser } = useAPI(`
        mutation createUser($email: String!, $password: String!, $firstName: String!, $lastName: String!, $turnstile: String){
            createUser(email: $email, password: $password, firstName: $firstName, lastName: $lastName, turnstile: $turnstile){
                id
            }
        }
    `)

    const fields = [
        {
            label: "Email", value: "", name: "email",
            validator: (val) => { return !/\S+@\S+\.\S+/.test(val)? 'Enter valid email address': null }
        },
        { label: "First Name", value: "", name: "firstName" },
        { label: "Last Name", value: "", name: "lastName" },
        { label: "Password", value: "", name: "password", type: 'new-password' }
    ]

    const buttons = [
        {
            label: 'Create',
            primary: true,
            onClick: async function (formData) {
                try {
                    const token = await turnstile.current.getToken(user?.internal)
                    const result = await createUser({ ...formData, turnstile: token })
                    if (!user.loggedIn) {
                        toast.success('Account created -- please log in.')
                        navigate('/') // let newy created user log in
                    } else
                        navigate('/users/' + result.createUser.id) // a logged in user created this so go to this profile
                } catch (err) {
                    toast.error(err[0]?.message ?? 'Error creating account.  Contact support.')
                    console.log(err)
                    turnstile.current.reset()
                }
            }
        }
    ]

    return (
        <div>
            <FormPage pageTitle="Account" title="Create Account" fields={fields} buttons={buttons}>
                <div ref={wrapperRef} style={{ marginTop: '50px' }}></div>
            </FormPage>
        </div>
    )
}
